<template>
  <form @submit.prevent="login">
    <b-alert variant="danger" show v-if="error">
      {{ error }}
    </b-alert>
    <string-form-field
      :label="$t('login.fields.username')"
      required
      v-model="username">
      <b-input-group-text slot="prepend">
        <i class="fa fa-fw fa-user"></i>
      </b-input-group-text>
    </string-form-field>
    <string-form-field
      :label="$t('login.fields.password')"
      required
      type="password"
      v-model="password">
      <b-input-group-text slot="prepend">
        <i class="fa fa-fw fa-key"></i>
      </b-input-group-text>
    </string-form-field>
    <b-button
      type="submit"
      variant="primary"
      block
      class="mt-4"
      @click.prevent="login">
      {{ $t('common.login') }}
    </b-button>
  </form>
</template>
<script>
import { LoggedUserService } from "vue-template";

export default {
  data() {
    return {
      username: null,
      password: null,
      error: null,
    };
  },

  methods: {
    async login() {
      try {
        this.error = null;
        const result = await LoggedUserService.login({
          username: this.username,
          password: this.password,
        });
        console.log(result);
        this.$emit('logged-in', result);
      } catch (e) {
        console.error(e);
        this.error = this.$error2text(e.data);
      }
    }
  }
};
</script>
